import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/SalesStore';
import { ClipLoader } from 'react-spinners';
import { css } from 'emotion';
import './SalesStyle.css'

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class Sales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagetype : 'full'
        };

    }
    componentDidMount() {
        this.ensureDataFetched('full');
    }

    renderSalesDataTable(props) {
        return (
            <div className="col-md-12">
                <table
                    id="datatable-1"
                    className="table table-datatable table-striped table-hover  dt-responsive"
                    style={{ width: '100%' }}
                >
                    <thead style={{ width: '100%', textAlign: "center" }}>
                        <tr>
                            <th>#</th>
                            <th>Invoice</th>
                            <th>Order</th>
                            <th>Order Date</th>
                            <th>Company</th>
                            <th>Reference/Booking</th>
                            <th>Traverse</th>
                            <th>Location</th>
                            <th>Sales</th>
                            <th>Commission</th>
                        </tr>
                    </thead>
                    <tbody style={{ width: '100%', textAlign: "center" }}>
                        {props.salesItems.map(inv => 
                            <tr key={inv.deliveryOrderId}>
                                <td>{inv.deliveryOrderId}</td>
                                <td>{inv.invoiceNumbers.props.children}</td>
                                <td>{inv.orderNumber}</td>
                                <td>{inv.orderDate}</td>
                                <td>{inv.companyName}</td>
                                <td>{inv.referenceNumber ? "REF: " + inv.referenceNumber:""} {inv.bookingNumber?"BN: "+inv.bookingNumber:""}</td>
                                <td>{inv.traverseTypeName}</td>
                                <td>
                                    <span className="badge badge-warning" title={inv.fromLocationAddress}>{inv.fromLocationName}</span> -
                                    <span className="badge badge-warning" title={inv.toLocationAddress}>{inv.toLocationName}</span>
                                </td>
                                <td>${inv.totalAmount}</td>
                                <td>${inv.totalAmount * inv.commissionPercentage / 100}</td>
                            </tr>
                            )}
                    </tbody>
                </table>

            </div>
        );
    }

    ensureDataFetched(pageType) {
        if (!this.props.isLoading) {
            this.props.requestSalesGetAll(pageType);
        }
    }

    fnPrepareSalesInfo(type) {
        if (this.props.salesInfo && this.props.salesInfo[type]) {
            return this.props.salesInfo[type];
        } else {
            return 0;
        }
    }

    render() {
        
        var inProgressAmount = 0;
        var paidToSales = 0;
        var hasWaitingPaymentInvoice = 0;
        var readyForPayToSales = 0;
        
        var salesInfo = this.props.salesInfo;
        if (salesInfo) {
            salesInfo.map(item => {
                if (item.status === "InProgress") {
                    inProgressAmount = item.totalAmount;
                } else if (item.status === "PaidToSales") {
                    paidToSales = item.totalAmount;
                } else if (item.status === "HasWaitingPaymentInvoice") {
                    hasWaitingPaymentInvoice = item.totalAmount;
                } else if (item.status === "ReadyForPayToSales") {
                    readyForPayToSales = item.totalAmount;
                }
            });
        }
        return (
            <main className="main-content p-5" role="main">
                <div className="row">
                    <div className="col-md-6 col-lg-6 col-xl-3 mb-5">
                        <div className="card card-tile card-xs bg-secondary bg-gradient text-center filter-card-button" onClick={() => this.ensureDataFetched("inProgress")}>
                            <div className="card-body p-4">
                                <div className="tile-left">
                                    <i className="batch-icon batch-icon-stopwatch batch-icon-xxl" />
                                </div>
                                <div className="tile-right">
                                    <div className="tile-number">${inProgressAmount}</div>
                                    <div className="tile-description">In Progress</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3 mb-5">
                        <div className="card card-tile card-xs bg-danger bg-gradient text-center filter-card-button" onClick={() => this.ensureDataFetched("waitingForPaymentFromCustomer")}>
                            <div className="card-body p-4">
                                <div className="tile-left">
                                    <i className="batch-icon batch-icon-users batch-icon-xxl" />
                                </div>
                                <div className="tile-right">
                                    <div className="tile-number">${hasWaitingPaymentInvoice}</div>
                                    <div className="tile-description">Waiting For Payment From Customer</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3 mb-5">
                        <div className="card card-tile card-xs bg-primary bg-gradient text-center filter-card-button" onClick={() => this.ensureDataFetched("myBalance")}>
                            <div className="card-body p-4">
                                <div className="tile-left">
                                    <i className="batch-icon batch-icon-inbox batch-icon-xxl" />
                                </div>
                                <div className="tile-right">
                                    <div className="tile-number">${readyForPayToSales}</div>
                                    <div className="tile-description">My Balance</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3 mb-5">
                        <div className="card card-tile card-xs bg-success bg-gradient text-center filter-card-button" onClick={() => this.ensureDataFetched("paymentsReceived")}>
                            <div className="card-body p-4">
                                <div className="tile-left">
                                    <i className="batch-icon batch-icon-wallet-alt batch-icon-xxl" />
                                </div>
                                <div className="tile-right">
                                    <div className="tile-number">${paidToSales}</div>
                                    <div className="tile-description">Payments Received</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                {
                    this.props.isLoading ? 
             (<main className="main-content" role="main">
                    <div className='sweet-loading' style={{ textAlign: 'center', marginTop: 20 }}>
                        <ClipLoader
                            className={override}
                            sizeUnit={"px"}
                            size={250}
                            color={'rgb(54, 215, 183)'}
                            loading={true}
                        />
                    </div>
                </main>)
                :
                    (<div className="row mb-5">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        {this.renderSalesDataTable(this.props)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>)
                }
            </main>
        );
    }
}


export default connect(
    state => state.salesData,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Sales);


// WEBPACK FOOTER //
// ./src/view/Sales/index.js